import { useState, useEffect } from "react";
import { 
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Grid,
    AppBar,
    Tabs,
    Tab,
    InputAdornment,
    Typography,
    DialogContent
} from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { actulizaTerrestreAction, obtenerCatalogoProveedorTerrestre, openModalEditarPaqueteAction } from "./../../../ducks/proveedorTerrestreDuck"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import ItinerarioForm from "../ItinerarioForm/ItinerarioForm";
import ExtrasCheckboxes, { convertExtrasToHTML, normalizarExtras, parseExtrasFromHTML } from "../../ProveedoresVuelos/ExtrasCheckboxes/ExtrasCheckboxes";
import useCatalogos from "../../../hooks/useCatalogos";
import AditamentosCustom from "../../ProveedoresVuelos/FAditamentosCustom/FAditamentosCustom";
import { obetenerPaqueteMayoristaListaDetalle } from "../../../ducks/proveedorMayoristaDuck";
import { FPAroveedoresTerrestresStyle } from "./styles";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const useCatalogoPrveedoresTerrestres = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCatalogoProveedorTerrestre()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    nombrePaquete: yup
        .string("Ingrese nombre de paquete")
        .required("Es requerido"),
})
const initialValues = {
    monto: 0,
    nombrePaquete: "",
}

const FPAroveedoresTerrestres = () => {
    const dispatch = useDispatch()
    const classes = FPAroveedoresTerrestresStyle()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const catalogoTerrestreIncluye = useCatalogos("Package/Includes")

    const [value, setValue] = useState(0)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [idProveedor, setIdProveedor] = useState(0)
    const [itinerario, setItenerario] = useState('<p><strong>Escribe aqui el itinerario</strong></p>')
    const [incluye, setIncluye] = useState('<p><strong>Escribe aqui lo que incluye</strong></p>')
    const [noIncluye, setNoIncluye] = useState('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
    const [selectedExtras, setSelectedExtras] = useState([]);
    const [customAditamentos, setCustomAditamentos] = useState([])
    const { catalogoTerrestre, paqueteSelect, openEditPaquete }  = useSelector(store => store.proveedorTerrestre)
    
    useCatalogoPrveedoresTerrestres()
    
    const open = openEditPaquete
    const normalizedExtras = normalizarExtras(catalogoTerrestreIncluye);
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })

    useEffect(() => {
        setValue(2)
        if (paqueteSelect?.IdPaqueteProveedorTerrestre > 0) {
            formik.setFieldValue("nombrePaquete", paqueteSelect.Nombre)
            formik.setFieldValue("monto", paqueteSelect.PrecioNeto)
            setTipoMoneda(paqueteSelect.Moneda?.id_moneda)
            setIdProveedor(paqueteSelect.Proveedor?.IdProveedor)
            setItenerario(paqueteSelect.Itinerario)
            setIncluye(paqueteSelect.Incluye)
            setNoIncluye(paqueteSelect.NoIncluye)
            setValue(0)
            
            const selectedExtrasIds = 
                paqueteSelect?.lIncluye?.length > 0
                    ? paqueteSelect?.lIncluye?.map(item => item.IdCatPaqueteAditamento)
                    : parseExtrasFromHTML(paqueteSelect?.Incluye, normalizedExtras);

            setSelectedExtras(selectedExtrasIds);

            const aditamentosIniciales = paqueteSelect?.lPaqueteAditamentoCustom?.map(aditamento => ({
                id: aditamento.IdPaqueteAditamentoCustom,
                nombre: aditamento.CatPaqueteAditamentoCustom.Descripcion,
                incluido: aditamento.Incluye
            }));

            setCustomAditamentos(aditamentosIniciales);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paqueteSelect])

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const onItinerarioValue = (value) => {
        setItenerario(value)
    }
    const handleSelecProveedor = (event) => {
        setIdProveedor(event.target.value)
    }
    const handleClose = () => {
        dispatch(openModalEditarPaqueteAction({ open: false, paquete: {} }))
        setTipoMoneda(0)
        setValue(0)
        setItenerario('<p><strong>Escribe aqui el itinerario</strong></p>')
        setIncluye('<p><strong>Escribe aqui lo que incluye</strong></p>')
        setNoIncluye('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
        formik.resetForm(initialValues)
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    const handleAddCustomAditamento = (nuevoAditamento) => {
        const nuevoId = Math.max(0, ...customAditamentos.map(a => a.id)) + 1;
        setCustomAditamentos([
            ...customAditamentos, 
            {
                id: nuevoId,
                nombre: nuevoAditamento.nombre || nuevoAditamento,
                incluido: nuevoAditamento.incluido || false
            }
        ]);
    }; 
    const handleRemoveCustomAditamento = (id) => {
        setCustomAditamentos(customAditamentos.filter(a => a.id !== id));
    };
    const handleToggleCustomAditamento = (id) => {
        setCustomAditamentos(customAditamentos.map(aditamento => 
            aditamento.id === id 
            ? { ...aditamento, incluido: !aditamento.incluido } 
            : aditamento
        ));
    };

    const onSave = (values) => {
        if (tipoMoneda === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una moneda valida",
            })
            return null
        }
        if (idProveedor === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una proveedor valido",
            })
            return null
        }
        
        // Transformar customAditamentos al formato requerido por la API
        const aditamentosCustomFormateados = customAditamentos.map(aditamento => ({
            Aditamento: aditamento.nombre,
            Incluye: aditamento.incluido
        }));
        
        dispatch(onLoadAnction({ message: '' }))
        dispatch(actulizaTerrestreAction({
            IdPaqueteProveedorTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre,
            ClavePaquete: "No aplica",
            IdMoneda: tipoMoneda,
            IdProveedor: idProveedor,
            Itinerario: itinerario,
            Nombre: values?.nombrePaquete,
            PrecioNeto: values?.monto,
            Incluye: incluye,
            NoIncluye: noIncluye,
            lCatIncluye: selectedExtras,
            lPaqueteAditamentoCustom: aditamentosCustomFormateados
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obetenerPaqueteMayoristaListaDetalle())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }

    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo={`Editar terrestre ${paqueteSelect?.Nombre}`}
            />

            <form onSubmit={formik.handleSubmit}>
                <DialogContent dividers className={classes.dialogContent}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={3}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoProveedor">Proveedor terrestre</InputLabel>
                                <Select
                                    labelId="lTipoProveedor"
                                    id="STipoProveedor"
                                    name="proveedor"
                                    value={idProveedor}
                                    onChange={handleSelecProveedor}
                                    label="Proveedor terrestre"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoTerrestre.map((item, index) => (
                                        <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                                            {item.RazonSocial}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                required
                                id="input-Nombre"
                                label="Nombre paquete"
                                type="text"
                                variant="outlined"
                                name="nombrePaquete"
                                value={formik.values.nombrePaquete}
                                onChange={formik.handleChange}
                                error={formik.touched.nombrePaquete && Boolean(formik.errors.nombrePaquete)}
                                helperText={formik.touched.nombrePaquete && formik.errors.nombrePaquete}
                                className={classes.textField}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                required
                                id="input-Monto"
                                label="Monto"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {paqueteSelect?.Moneda ? `${paqueteSelect?.Moneda.Clave}` : ""}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    
                    <Grid container className={classes.containerSpacing}>
                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="Itinerario" {...a11yProps(0)} />
                                <Tab label="Incluye / No Incluye" {...a11yProps(1)} />
                                {/* <Tab label="No Incluye" {...a11yProps(2)} /> */}
                            </Tabs>
                        </AppBar>

                        <TabPanel value={value} index={0} className={classes.tabPanel}>
                            <ItinerarioForm onChange={onItinerarioValue} initialValue={itinerario} />
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            <Box className={classes.boxContainer}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '1rem' }}>
                                            <strong>Aditamentos generales del paquete</strong>
                                        </Typography>

                                        <ExtrasCheckboxes 
                                            extrasList={normalizedExtras} 
                                            selectedIds={selectedExtras}
                                            onSelectionChange={(newIds) => {
                                                setSelectedExtras(newIds);
                                                // Opcional: mantener compatibilidad con strings HTML
                                                setIncluye(convertExtrasToHTML(newIds, normalizedExtras, true));
                                                setNoIncluye(convertExtrasToHTML(newIds, normalizedExtras, false));
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <AditamentosCustom
                                            customAditamentos={customAditamentos}
                                            onAddCustomAditamento={handleAddCustomAditamento}
                                            onRemoveCustomAditamento={handleRemoveCustomAditamento}
                                            onToggleInclusion={handleToggleCustomAditamento}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </TabPanel>
                        {/* <TabPanel value={value} index={2}>
                            <ControllerEditor onValue={onNoIncluyeValue} content={noIncluye} />
                        </TabPanel> */}
                    </Grid>
                </DialogContent>

                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </ModalBase>
    )
}
export default FPAroveedoresTerrestres